import { PassengerType } from "@/models/Enums";

export const passengerOptions = [
  {
    label: "Adult",
    description: "Aged 16 and over",
    resourceCode: "PAX",
    resourceType: "A",
    type: "STD",
    passengerType: PassengerType.Adult,
    displayDefault: true,
  },
  {
    label: "Adult Concession",
    description: "Aged 60 +/ students / disabled passengers",
    resourceCode: "PAX",
    resourceType: "A",
    type: "VCN",
    passengerType: PassengerType.AdultConcession,
    displayDefault: true,
  },
  {
    label: "Child",
    description: "Aged 5-15 yrs",
    resourceCode: "PAX",
    resourceType: "C",
    type: "STD",
    passengerType: PassengerType.Child,
    displayDefault: true,
  },
  {
    label: "Infant",
    description: "Aged 0-4 yrs",
    resourceCode: "PAX",
    resourceType: "I",
    type: "STD",
    passengerType: PassengerType.Infant,
    displayDefault: true,
  },
  {
    label: "Child Concession",
    description: "Aged 4-15 yrs",
    resourceCode: "PAX",
    resourceType: "C",
    type: "VCN",
    passengerType: PassengerType.ChildConcession,
    displayDefault: false,
  },
  {
    label: "Infant Concession",
    description: "Aged 0-4 yrs",
    resourceCode: "PAX",
    resourceType: "I",
    type: "VCN",
    passengerType: PassengerType.InfantConcession,
    displayDefault: false,
  },
];
